import { BaseItem, ProductItem } from '../../UserData/_stores/UserCartStore'
import type UserCartStore from '../../UserData/_stores/UserCartStore'

interface GoogleItem {
  item_id: string
  item_name: string
  price: number
  quantity: number
}

interface PinterestItem {
  product_id: string
  product_name: string
  product_price: number
  product_quantity: number
}

export function buildGoogleItems(cart: UserCartStore): GoogleItem[] {
  const items: GoogleItem[] = []

  cart.get('items').forEach((item) => {
    items.push({
      item_id: getItemTrackingId(item),
      item_name: getItemTrackingName(item),
      price: item.get('price').toDinero().toUnit(),
      quantity: item.get('quantity')
    })
  })

  return items
}

export function buildPinterestItems(cart: UserCartStore): PinterestItem[] {
  const items: PinterestItem[] = []

  cart.get('items').forEach((item) => {
    items.push({
      product_id: getItemTrackingId(item),
      product_name: getItemTrackingName(item),
      product_price: item.get('price').toDinero().toUnit(),
      product_quantity: item.get('quantity')
    })
  })

  return items
}

export function getItemTrackingId(item: BaseItem): string {
  const trackingId = item.get('tracking_id')
  if (trackingId !== '') {
    return trackingId
  }

  if (item instanceof ProductItem) {
    const optionIds = item.get('options').valueSeq()
      .map(option => option.get('id'))
      .toArray()
      .sort((a, b) => a - b)

    return ['product', item.get('product_id'), ...optionIds].join('-')
  }

  if (item.get('type').startsWith('sample_pack_preprinted_')) {
    return item.get('type')
  }

  return item.get('type') + '-' + item.get('id')
}

function getItemTrackingName(item: BaseItem): string {
  return item instanceof ProductItem ? item.get('product_name') : item.get('name')
}
